import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const heroSlides = [
  {
    id: 1,
    title: '长安三万里',
    subtitle: '盛世长安，诗酒年华',
    description: '追光动画十年力作，带你重返大唐盛世，感受李白与高适的千古友情',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Tang%20Dynasty%20Changan%20city%20at%20sunset%20with%20golden%20light%2C%20traditional%20Chinese%20architecture%20with%20flying%20eaves%2C%20poetic%20atmosphere%2C%20warm%20amber%20tones%2C%20cinematic%20wide%20shot%2C%20epic%20scale%2C%20soft%20painterly%20style&width=1800&height=900&seq=hero-slide-1&orientation=landscape',
    link: '/article/1',
  },
  {
    id: 2,
    title: '流浪地球3',
    subtitle: '带着家园去流浪',
    description: '中国科幻巅峰之作第三部，人类命运共同体史诗新篇章',
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20scene%20with%20Earth%20propelled%20by%20giant%20engines%20through%20nebula%2C%20stars%20and%20galaxies%20in%20background%2C%20dramatic%20blue%20and%20orange%20lighting%2C%20massive%20scale%2C%20cinematic%20wide%20shot&width=1800&height=900&seq=hero-slide-2&orientation=landscape',
    link: '/article/2',
  },
  {
    id: 3,
    title: '庆余年第二季',
    subtitle: '权谋天下，谁主沉浮',
    description: '现象级古装权谋大剧续作，范闲归来再掀波澜',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20interior%20with%20intricate%20wooden%20carvings%2C%20warm%20candlelight%2C%20mysterious%20atmosphere%2C%20traditional%20Chinese%20aesthetics%2C%20dramatic%20shadows%2C%20cinematic%20composition&width=1800&height=900&seq=hero-slide-3&orientation=landscape',
    link: '/article/5',
  },
];

export default function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {heroSlides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}
        >
          <img
            src={slide.image}
            alt={`${slide.title} - ${slide.subtitle} - 蚂蚁影视`}
            title={`${slide.title} - ${slide.subtitle} - 蚂蚁影视高清免费在线观看`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30" />
        </div>
      ))}

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-[1200px] mx-auto">
            <div className="max-w-xl">
              <p className="text-accent-400 text-sm md:text-base font-medium mb-3 animate-fadeIn">
                {heroSlides[currentSlide].subtitle}
              </p>
              <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-4 leading-tight">
                {heroSlides[currentSlide].title}
              </h1>
              <p className="text-background-50/80 text-sm md:text-base mb-6 max-w-md leading-relaxed">
                {heroSlides[currentSlide].description}
              </p>
              <button
                onClick={() => navigate(heroSlides[currentSlide].link)}
                className="px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-fill mr-2" />
                立即观看
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              index === currentSlide
                ? 'bg-primary-500 w-6'
                : 'bg-background-50/50 hover:bg-background-50/80'
            }`}
            aria-label={`切换到第 ${index + 1} 张`}
          />
        ))}
      </div>
    </section>
  );
}